<template>
    <div class="success-email__content" v-bind:class="{ authorized: accessToken }">
        <Sidebar v-show="accessToken"></Sidebar>
        <div class="no-autorized__img"></div>
        <div class="content-wrapper success-email__wrapper">
            <div class="img-desktop img-desktop-oops d-none d-lg-inline-block"></div>

            <section class="content-header">
                <div class="container-fluid">
                    <div class="row mb-2 alert-container"></div>
                </div>
            </section>

            <section class="content content-header">
                <div class="container-fluid">
                    <div class="col-sm-10 col-md-8 col-xl-8 facturation-alert">
                        <i class="fas fa-info"></i> {{ getMessage }}
                    </div>
                </div>
            </section>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
    import Footer from '../components/Footer';
    import Sidebar from '../components/Sidebar';
    import { mapGetters } from 'vuex';

    export default {
        data() {
            return {
                shortCodeToMessageMap: {
                    'wrong_status_to_validate': `Cette demande de dispense n'est pas encore éligible
                        à l'action que vous essayer de réaliser.`,
                    'due_sign': `Une erreur s'est produite lors de la signature. Veuillez
                        contacter votre interloculeur dans l'entreprise.`,
                    'token_expired': `Le lien a expiré. Pour obtenir un nouveau lien rapprochez vous
                        de votre pole RH.`,
                    'due_token_expired': `Le lien a expiré. Pour obtenir un nouveau lien rapprochez
                        vous de votre pole RH`,
                    'exemption_sign': `Une erreur s'est produite lors de la signature. Veuillez
                        contacter votre interloculeur dans l'entreprise.`,
                    'aborted_exemption': 'Cette demande de dispense a été abandonnée.',
                    'already_validated_exemption': 'Cette demande de dispense a déjà été validée.',
                }
            }
        },
        computed: {
            ...mapGetters({
                accessToken: 'accessToken'
            }),
            getMessage() {
                return this.shortCodeToMessageMap[this.$route.params.messageShortCode] ?? 'Oops'
            },
        },
        components: {
            Footer,
            Sidebar
        }
    }
</script>
